module.exports = __webpack_public_path__ + "img/Clock.cdce24c4.svg";